<template>
  <div class="app-menu-dialog">
    <!-- SETA O BACKGROUND QUE VAI FECHAR A PAGINA AO CLICAR FORA -->
    <div class="dialog-bg" @click="cpntOnFechar" @mouseout='() => { cpntOnFechar({ type: "mouseleave" }) }'>&nbsp;</div>

    <!-- SETA OS DADOS DA TELA -->
    <div class="dialog-conteudo" ref="conteudo" @mouseleave='cpntOnFechar' @mouseout='() => { cpntOnFechar({ type: "mouseenter" }) }'>
      <!-- COLOCA O TITULO -->
      <header class="app-dialog-header" v-if="Object.keys($slots).indexOf('titulo') !== -1">
        <slot name="titulo"></slot>
      </header>

      <!-- COLOCA O CONTEUDO -->
      <div class="app-dialog-body" :class="(Object.keys($slots).indexOf('titulo') !== -1 ? 'sem-canto-redondo-top' : '') + ' ' + (Object.keys($slots).indexOf('rodape') !== -1 ? 'sem-canto-redondo-bottom' : '')">
        <slot></slot>
      </div>

      <!-- COLOCA O RODAPE -->
      <footer class="app-dialog-footer" v-if="Object.keys($slots).indexOf('rodape') !== -1">
        <slot name="rodape"></slot>
      </footer>

      <!-- FAZ O BIQUINHO -->
      <div class="arrow" data-popper-arrow></div>
    </div>
  </div>
</template>

<style scoped>
  .app-menu-dialog > .dialog-bg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 2500;
  }
  .app-menu-dialog > .dialog-conteudo {
    background: #e0e0e0;
    -webkit-box-shadow: 8px 8px 10px -5px rgba(189,189,189,1);
    -moz-box-shadow: 8px 8px 10px -5px rgba(189,189,189,1);
    box-shadow: 8px 8px 10px -5px rgba(189,189,189,1);
    text-align: left;
    color: #444;
    z-index: 2502;
    padding: 2px;
    background: #bbb;
    border-radius: 5px;
  }
    .app-menu-dialog > .dialog-conteudo > .app-dialog-header {
      background: #e9e9e9;
      border-bottom: 1px solid #ccc;
      padding: 10px 5px;
    }
    .app-menu-dialog > .dialog-conteudo > .app-dialog-footer {
      background: #e9e9e9;
      border-top: 1px solid #ccc;
      padding: 10px 5px;
    }
    .app-menu-dialog > .dialog-conteudo > .app-dialog-body,
    .app-menu-dialog > .dialog-conteudo > .app-dialog-footer {
      padding: 5px;
    }
    .app-menu-dialog > .dialog-conteudo > .app-dialog-body {
      background: #fff;
      border-radius: 5px;
    }

    .app-menu-dialog > .dialog-conteudo > .app-dialog-body.sem-canto-redondo-top {
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
    }
    .app-menu-dialog > .dialog-conteudo > .app-dialog-body.sem-canto-redondo-bottom {
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
    }

  .dialog-conteudo > .arrow,
  .dialog-conteudo > .arrow::before {
    position: absolute;
    width: 8px;
    height: 8px;
    z-index: -1;
  }

  .dialog-conteudo > .arrow::before {
    content: '';
    transform: rotate(45deg);
    background: #bbb;
  }

  .app-menu-dialog > .dialog-conteudo[data-popper-placement^='top'] > .arrow {
    bottom: -4px;
  }

  .app-menu-dialog > .dialog-conteudo[data-popper-placement^='bottom'] > .arrow {
    top: -4px;
  }

  .app-menu-dialog > .dialog-conteudo[data-popper-placement^='left'] > .arrow {
    right: -4px;
  }

  .app-menu-dialog > .dialog-conteudo[data-popper-placement^='right'] > .arrow {
    left: -4px;
  }
</style>

<style>
 [data-popper-placement='top'] {
   border-top-style: none !important
 }
</style>

<script>
  import { createPopper } from '@popperjs/core';

  export default {
    props: {
      cpntElement: {
        required: true
      },
      cpntOnFechar: {
        required: true
      },
      cpntAlignX: {
        required: false,
        type: String,
        default: function () {
          return 'auto'
        }
      },
      cpntPositionFixed: {
        required: false,
        type: Boolean,
        default: function () {
          return false
        }
      }
    },
    data: function () {
      return {
        referencia: {},
        campo: {}
      }
    },
    mounted: function () {
      // SETA INICIA O POSICIONAMENTO DO CONTEUDO
      this.dialogRefConteudo()

      // INICIA O POSICIONAMENTO DO BIQUINHO
      // this.dialogRefBiquinho()
    },
    methods: {
      dialogRefConteudo: function () {
        // SETA AS OPÇÕES
        var button = this.cpntElement
        var tooltip = this.$refs.conteudo
        var fixed = this.cpntPositionFixed
        var posicao = this.cpntAlignX

        // SETA OS OPTIONS A SEREM UTILIZADOS
        var options = {
          positionFixed: fixed,
          placements: posicao,
          strategy: 'fixed',
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 0],
              },
            }
          ]
        }

        // INICIA A VARIAVEL
        var parar = false
        var target = button
        
        // PROCURA O ELEMENTO PAI PRA SABER SE ESTÁ DENTRO DE UM SELECT2
        while (parar === false) {
          if (target.tagName === 'BODY' || target.className.indexOf('app-dialog') !== -1) {
            parar = true
          } else {
            target = target.parentElement
          }
        }

        // VERIFICA SE DEVE INCLUIR A CLASS PARA DIALOG
        if (target.className.indexOf('app-dialog') !== -1) {
          options.strategy = 'fixed'
        }

        // INICIA A DIALOG
        createPopper(button, tooltip, options)
      }
    }
  }
</script>
